<template>
  <div v-if="!isTransparent" class="gameHeader">
    <div class="header-search">
      <van-icon
        class="sign"
        name="./imgs/icon-sign-black.png"
        @click="toSign"
        :dot="isSignRed === 1"
      />
      <img
        src="@/assets/images/img_search.png"
        alt=""
        class="icon-search"
        @click="toSearch"
      />
      <van-icon
        name="./imgs/icon-download-black.png"
        @click="toMyGame"
        class="download"
      />
      <van-icon
        name="./imgs/icon-msg-black.png"
        @click="toMsg"
        class="msg"
        :dot="isMsgRed === 1"
      />
    </div>
    <div class="cheader">
      <span
        class="cbtn"
        v-for="(item, index) in tabs"
        :key="index"
        :class="activeIndex === index ? 'active' : ''"
        @click="isswitch(index)"
      >
        {{ item.title }}
      </span>
    </div>
  </div>
  <div v-else class="dGameHeader">
    <div class="header-search">
      <van-icon
              class="sign"
              name="./imgs/icon-sign-black.png"
              @click="toSign"
              :dot="isSignRed === 1"
      />
      <img
              src="@/assets/images/img_search.png"
              alt=""
              class="icon-search"
              @click="toSearch"
      />
      <van-icon
              name="./imgs/icon-download-black.png"
              @click="toMyGame"
              class="download"
      />
      <van-icon
              name="./imgs/icon-msg-black.png"
              @click="toMsg"
              class="msg"
              :dot="isMsgRed === 1"
      />
    </div>
    <div class="cheader">
      <span
              class="cbtn"
              v-for="(item, index) in tabs"
              :key="index"
              :class="activeIndex === index ? 'active' : ''"
              @click="isswitch(index)"
      >
        {{ item.title }}
      </span>
    </div>
  </div>
</template>

<script>
  import { reqHomeTitleData } from "@/api/moregame";
  import { getNavTitles, setNavTitles } from "@/util/homeNavTitle";
  export default {
    name: "gameHeader",
    props: ["isSignRed", "isMsgRed","isTop"],
    data() {
      return {
        isTransparent: true,
        signRed: true,
        msgRed: true,
        activeIndex: 0,
        tabs: getNavTitles()
      };
    },
    watch: {
      isTop(val) {
        const moreGameTabIndex = sessionStorage.getItem('moreGameTabIndex');
        //首页该咋咋
        if(moreGameTabIndex==undefined||moreGameTabIndex==0){
          this.isTransparent = val
        }else{
          this.isTransparent = false
        }
      },
    },
    created() {
      this.getHomeTitleData();
    },
    methods: {
      async getHomeTitleData() {
        try {
          const re = await reqHomeTitleData();
          if (!this.tabs || this.tabs.length === 0) {
            this.tabs = re.list;
            setNavTitles(re.list);
          }
          
        } catch (error) {
          // console.log(error, "getHomeTitleData");
        }
      },
      toSearch() {
        this.$router.push({name:'search'});
      },
      toSign() {
        this.$router.push({name:'signIn'});
      },
      toMyGame() {
        sessionStorage.setItem('myGameFromPath','moreGame')
        this.$router.push({name:'myGame'});
      },
      toMsg() {
        this.$router.push({name:'message'});
      },
      isswitch(index) {
        if(index==this.activeIndex){
          return
        }
        if(index==0){
          this.isTransparent = true
        }else{
          this.isTransparent = false
        }
        sessionStorage.setItem('moreGameTabIndex',index)
        this.activeIndex = index;
        let path = this.tabs[index].path;
        this.$router.push({name:path});
      },
      freshTabStatus() {
        if (!this.tabs) {
          return;
        }
        let activePath = this.$route.path.split("/")[2];
        this.tabs.forEach((item, index) => {
          if (item.path === activePath) {
            this.activeIndex = index;
            if(index!=0){
              this.isTransparent = false
            }
          }
        });
      },
    },
    mounted() {
      const tab = sessionStorage.getItem('moreGameTabIndex')
      if(tab){
        this.activeIndex = parseInt(tab);
      }else{
        this.freshTabStatus();
      }
    },
    destroyed() {
      sessionStorage.removeItem('moreGameTabIndex')
    }
  };
</script>
<style lang="scss" >
</style>

<style lang="scss" scoped>
  .gameHeader {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 212px;
    background: #f8f8f8;;
    .header-search {
      padding: 0 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 33px;
      ::v-deep .sign {
        .van-icon__image {
          width: 52px;
          height: 43px;
        }
      }
      .icon-search {
        width: 460px;
        height: 60px;
        margin-left: 30px;
      }
      ::v-deep .download {
        .van-icon__image {
          width: 52px;
          height: 42px;
        }
        margin-left: 15px;
      }
      ::v-deep .msg {
        .van-icon__image {
          width: 47px;
          height: 43px;
        }
        margin-left: 15px;
      }
    }
    .cheader {
      width: 100%;
      padding: 0 30px;
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
      background-color: transparent;
      align-items: center;
      .cbtn {
        padding-bottom: 6px;
        font-size: 30px;
        color: #9498a6;
        padding-bottom: 10px;
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }
      .active {
        text-decoration: underline;
        text-decoration-color: #56B7BD;
        text-decoration-thickness: 8px;
        text-underline-offset: -3px;
        font-size: 36px;
        color: #272727;
      }
    }
  }
  .dGameHeader {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 212px;
    background: transparent;
    .header-search {
      padding: 0 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 33px;
      ::v-deep .sign {
        .van-icon__image {
          width: 52px;
          height: 43px;
        }
      }
      .icon-search {
        width: 460px;
        height: 60px;
        margin-left: 30px;
        opacity:0.50
      }
      ::v-deep .download {
        .van-icon__image {
          width: 52px;
          height: 42px;
        }
        margin-left: 15px;
      }
      ::v-deep .msg {
        .van-icon__image {
          width: 47px;
          height: 43px;
        }
        margin-left: 15px;
      }
    }
    .cheader {
      width: 100%;
      padding: 0 30px;
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
      background-color: transparent;
      align-items: center;
      .cbtn {
        padding-bottom: 6px;
        font-size: 30px;
        color: white;
        padding-bottom: 10px;
        &:first-child {
          margin-left: 0;
        }
        &:last-child {
          margin-right: 0;
        }
      }
      .active {
        text-decoration: underline;
        text-decoration-color: #56B7BD;
        text-decoration-thickness: 8px;
        text-underline-offset: -3px;
        font-size: 36px;
        color: white;
      }
    }
  }
</style>
